import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {
  RecoilRoot,
  RecoilEnv
} from "recoil";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { queryClient } from "./lib/queryClient";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root")!);
RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED=false;
root.render(
  <RecoilRoot>
    <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId="940959229486-ulavvahgu7oh3ujsmhkkd14udp38olrh.apps.googleusercontent.com">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </GoogleOAuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </RecoilRoot>
);
